module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_gaseosas_vidrio_350_sch_pomelo_sa.5f098343.png";